import React from 'react';
import { Window, Heading, Lines } from '@components/desktop';

const ResearchWindow = () => (
  <Window id="research">
    <Heading>Research</Heading>
    <Lines>
      <li>
        <span>Sleep patterns as an alternative to epoch training</span>
      </li>
      <li>
        <span>Publication coming soon...</span>
      </li>
    </Lines>
  </Window>
);

export default ResearchWindow;
